var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBildmarke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 414",
    style: {
      enableBackground: "new 0 0 500 414"
    },
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cosee TechTalks Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50AF47",
    d: "M430.8,180.3c0-87.1-61.4-159.8-143.3-177.3c62.4,34,104.7,100.1,104.7,176.1c0,78.8-45.5,146.9-111.6,179.7 C365.9,344.1,430.8,269.8,430.8,180.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D800",
    d: "M499.4,180.3c0-87.1-61.4-159.8-143.3-177.3c62.4,34,104.7,100.1,104.7,176.1c0,78.8-45.5,146.9-111.6,179.7 C434.5,344.1,499.4,269.8,499.4,180.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M360.7,181.6c0,99.2-80.4,179.6-179.6,179.6c-29.6,0-57.6-7.2-82.2-19.9L5.2,410l40.1-111 C18,267.5,1.5,226.5,1.5,181.6C1.5,82.4,81.9,2,181.1,2S360.7,82.4,360.7,181.6z M175,127.4c-2-1.8-21.7-23.8-57.8-23.1 c-42.9,0.9-75.6,36.9-75.3,75.6c0.4,42.4,31.4,77.8,75.9,77.8c37.2,0,57-23.2,57.7-23.8l-18.8-21.5c-0.3-0.5-15,19.3-39,17.3 c-33.9-2.9-46.2-31.3-45.8-49.8c0.5-23.2,19.6-47.2,46.6-47.4c22.6-0.1,34.6,14.7,36.8,16.5L175,127.4z M245,104.3 c-45.5,0-78.3,34.3-78.3,76.7s32.7,76.7,78.3,76.7c44,0,77.8-34.3,77.8-76.7S288.6,104.4,245,104.3z M244.6,132.7 c-26.5,0-47.9,21.7-47.9,48.5s21.4,48.5,47.9,48.5s47.9-21,47.9-48.5C292.5,154.4,271.7,132.7,244.6,132.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBildmarke);
export default __webpack_public_path__ + "static/media/Logo_Bildmarke.750261291b7ea358b28afa082eb87a78.svg";
export { ForwardRef as ReactComponent };